export type Breakpoint =
  'mobile-s' | 'mobile-m' | 'mobile-l' | 'tablet' | 'laptop';

export const BREAKPOINTS: Record<Breakpoint, number> = {
  'mobile-s': 360,
  'mobile-m': 375,
  'mobile-l': 425,
  'tablet': 768,
  'laptop': 1024,
};

export const getBreakpoint = (viewportWidth: number): Breakpoint => {
  return (
    (Object.keys(BREAKPOINTS) as Breakpoint[])
      .reverse()
      .find((breakpoint) => viewportWidth >= BREAKPOINTS[breakpoint]) ||
    'mobile-s'
  );
};
